<template>
    <v-container fliud>
        <v-row class="d-flex justify-center align-center">
            <v-col md="auto">
                <v-progress-circular
                    :value="percent"
                    :rotate="-90"
                    :size="70"
                    :width="15"
                    color="primary">
                    <template v-if="whole === 0">
                        <v-icon color="primary">mdi-infinity</v-icon>
                    </template>
                    <template v-else>
                        {{ percent }}
                    </template>
                </v-progress-circular>
            </v-col>
            <v-col md="auto" align="center">
                {{ display }}
                <br>
                <span v-if="!isGoalComplete">{{ amountLeft }} remaining</span>
                <span v-else>Congrats! You're all done!</span>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
const formatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD'
})

export default {
    props: ['part','whole'],
    computed: {
        percent() {
            return (this.part / this.whole * 100).toFixed(0) + '%'
        },
        display() {
            return formatter.format(this.part) + ' / ' + formatter.format(this.whole)
        },
        amountLeft() {
            return formatter.format(this.whole - this.part)
        },
        getPart() {
            return formatter.format(this.part)
        },
        getWhole() {
            return formatter.format(this.whole)
        },
        isGoalComplete() {
            if (this.whole - this.part <= 0) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>

<style>

</style>